import React from 'react';
import { Box, TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ShoppingListFormData } from '../types/ShoppingList';

interface ShoppingListFormProps {
  formData: ShoppingListFormData;
  onChange: (field: keyof ShoppingListFormData, value: string) => void;
  errors?: Partial<Record<keyof ShoppingListFormData, string>>;
}

const ShoppingListForm: React.FC<ShoppingListFormProps> = ({ formData, onChange, errors = {} }) => {
  return (
    <Box component="form" noValidate autoComplete="off">
      <Grid container spacing={2}>
        {/* Name - full width */}
        <Grid size={12}>
          <TextField
            label="List Name"
            value={formData.name}
            onChange={(e) => onChange('name', e.target.value)}
            fullWidth
            required
            error={!!errors.name}
            helperText={errors.name}
          />
        </Grid>

        {/* Description */}
        <Grid size={12}>
          <TextField
            label="Description"
            value={formData.description}
            onChange={(e) => onChange('description', e.target.value)}
            fullWidth
            multiline
            rows={3}
            placeholder="e.g., Weekly groceries, Party supplies, etc."
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ShoppingListForm;